import ShortSpecifications from '@components/display/offer/ShortSpecifications'

import styles from 'styles/OfferShortSpecificationsAlt.module.css'

const ShortSpecificationsAlt = (props) => (
    <ShortSpecifications {...props} altStyles={styles} showtext />
)

export default ShortSpecificationsAlt